// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__2BMoe","desc":"Title_desc__tjktN","large":"Title_large__OG8YC"};